
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'babel-polyfill';
require('../vn/bootstrap');
require('../vn/data-lightbox')();

window.Notify = require('../vn/Notify');

// window.Vue = require('vue');
import Vue from 'vue';
Vue.prototype.url = url; // make url() accesible in vue templates

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


Vue.component('tooltip', require('./Tooltip').default);
Vue.component('contact-form', require('./ContactForm').default);
Vue.component('text-select', require('./TextSelect').default);
Vue.component('enum-form', require('./EnumForm').default);
Vue.component('user-student-school-select', require('./UserStudentSchoolSelect').default);
Vue.component('user-senior-school-select', require('./UserSeniorSchoolSelect').default);
Vue.component('language-form', require('./LanguageForm').default);

Vue.component('firma-form', require('./FirmaForm').default);

Vue.component('job-index', require('./JobIndex').default);
Vue.component('job-index-hp', require('./JobIndexHp').default);
Vue.component('job-index-item', require('./JobIndexItem').default);
Vue.component('job-favourite', require('./JobFavourite').default);

Vue.component('event-widget', require('./EventWidget').default);
Vue.component('event-index', require('./EventIndex').default);
Vue.component('event-index-item', require('./EventIndexItem').default);
Vue.component('event-user-form', require('./EventUserForm').default);

Vue.component('carousel', require('./Carousel').default);
Vue.component('home-carousel', require('./HomeCarousel').default);
Vue.component('attachment-form', require('./AttachmentForm').default);
Vue.component('unread-messages-badge', require('./UnreadMessagesBadge').default);
Vue.component('cookie-consent', require('./CookieConsent').default);

Vue.component('most-lego-form', require('./MostLegoForm').default);


const app = new Vue({
    el: '#app'
});
